export default __webpack_public_path__ + "static/media/chuter.1ee60d79.png";